import { createApp } from 'vue';
import VariantSelector from '../vue/VariantSelector';
import debounce from 'lodash.debounce';
import { getElementFromEvent } from '../utils';

class Ecommerce {
	cartState;
	isCartOpen = false;
	apps = [];
	container = null;

	constructor() {
		// Shop WP hooks
		wp.hooks.addAction('on.cartUpdate', 'shopwp', (cartState) => {
			this.cartState = cartState;
			this.updateCartButtons();
		});

		wp.hooks.addAction(
			'on.cartToggle',
			'shopwp',
			debounce((data) => {
				this.isCartOpen = data.isCartOpen;

				if (data.isCartOpen) {
					console.log('Cart is open');
				} else {
					console.log('Cart is closed');
				}
			}, 50)
		);

		wp.hooks.addFilter('misc.linkHref', 'shopwp', (linkHref, linkTo, payload) => {
			const lang = document.documentElement.getAttribute('lang');

			if (lang !== 'nl-NL') {
				// nl is the default language
				linkHref = linkHref.replace('/products/', '/' + lang.split('-')[0] + '/products/');
			}

			return linkHref;
		});


		try {
			//dynamisch alle vertalingen voor teksten inladen
			const translationsJson = document.querySelector('[data-ecommerce-translations]') ?? '';
			const translationGroups = JSON.parse(translationsJson?.textContent ?? '{}');

			Object.keys(translationGroups).forEach(group => {
				const translations = translationGroups[group];
				Object.keys(translations).forEach(key => {
					const filter = `${group}.${key}`;
					wp.hooks.addFilter(filter, 'shopwp', (defaultValue, cartData, cartState) => {
						//de huidige set vertalingen inladen (kan veranderd zijn na barba navigatie)
						const translationsJson = this?.container?.querySelector('[data-ecommerce-translations]') ?? '';
						const translations = JSON.parse(translationsJson?.textContent);

						const translation = translations[group][key];
						if(translation) {
							return translation;
						}

						return defaultValue;
					});
				})
			});
		}catch(e){
			console.error(e);
		}


		// Events
		document.addEventListener('click', (e) => {
			const button = getElementFromEvent(e, '[data-open-cart]');

			if (!button) {
				return;
			}

			// Shop WP bug: first close the cart then wait for the next tick of the event loop to open it
			wp.hooks.doAction('do.cartToggle', 'close');

			setTimeout(() => {
				wp.hooks.doAction('do.cartToggle', 'open');
			}, 0);
		});

		document.addEventListener('bless', (e) => {
			this.init(e.target);
			this.updateCartButtons();
		});

		document.addEventListener('afterLeave', (e) => {
			this.cleanUp();
		});
	}

	updateCartButtons() {
		if (!this.cartState) {
			return;
		}

		document.querySelectorAll('[data-cart-quantity]').forEach((button) => {
			button.innerHTML = `${this.cartState.cartData.totalQuantity}`;
		});
	}

	init(element) {
		if (!element) {
			return;
		}

		this.container = element.closest('[data-barba="container"]');

		element.querySelectorAll('[data-variant-selector]').forEach((wrapper) => {
			const app = createApp({
				components: {
					'variant-selector': VariantSelector,
				},
			});
			app.mount(wrapper);
			this.apps.push(app);
		});
	}

	cleanUp() {
		this.apps.forEach((app) => {
			app.unmount();
		});
		this.apps = [];
	}
}

export const ecommerce = new Ecommerce();
